import { render, staticRenderFns } from "./ImagenesWeb.vue?vue&type=template&id=4389af05"
import script from "./ImagenesWeb.vue?vue&type=script&lang=js"
export * from "./ImagenesWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports